import { render, staticRenderFns } from "./DonwloadIntegration.vue?vue&type=template&id=90b4d44e&"
import script from "./DonwloadIntegration.vue?vue&type=script&lang=js&"
export * from "./DonwloadIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports